import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Login from './account/login';
import Header from './account/header';
import Home from './home/Home';
import Dashboard from './dashboard/dashboard';
import AdAddPage from './AddPage/addfbpage';
import FileUploadComponent from './AddPage/importleads';
import SendLeads from './AddPage/sendlead';
import DownloadLeads from './AddPage/downloadleads.js';
import Analysis from './AddPage/analysis.js';
import FetchLeads from './AddPage/fetch_leads.js';
import Accounts from './AddPage/accounts.js';
import GruhkhojDashboard from './gruhkhoj/gruhkhoj.js';
const App = () => {
  return (
    <BrowserRouter>
      <Header />
      <Routes>
        <Route exact path="/" element={<Login />} />
        <Route exact path="/home" element={<Home />} />
        <Route exact path="/dashboard" element={<Dashboard />} />
        <Route exact path="/add_page" element={<AdAddPage />} />
        <Route exact path="/import_leads" element={<FileUploadComponent />} />
        <Route exact path="/send_leads" element={<SendLeads />} />
        <Route exact path="/download_leads" element={<DownloadLeads />} />
        <Route exact path="/analysis" element={<Analysis />} />
        <Route exact path="/accounts" element={<Accounts />} />
        <Route exact path="/fetch_leads" element={<FetchLeads />} />
        <Route exact path="/gruhkhoj" element={<GruhkhojDashboard />} />


      </Routes>
    </BrowserRouter>
  );
};

export default App;
